import React, { useState, useRef, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Navbar.css';
import afribet from '../assets/afribet.png';
import { FaMoon, FaSun, FaUser, FaBullseye, FaWallet, FaSignOutAlt, FaChevronUp, FaChevronDown } from 'react-icons/fa';

export default function Navbar({ user, balance, betCount, onLogin, onRegister, onLogout, theme, toggleTheme }) {
  const location  = useLocation();
  const navigate  = useNavigate();
  const [menuOpen, setMenuOpen]   = useState(false);
  const [userMenu, setUserMenu]   = useState(false);
  const userMenuRef = useRef(null);

  // Close user dropdown on outside click
  useEffect(() => {
    const handler = (e) => {
      if (userMenuRef.current && !userMenuRef.current.contains(e.target)) {
        setUserMenu(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const navLinks = [
    { to: '/',              label: 'Accueil' },
    { to: '/sports',        label: 'Sports'  },
    { to: '/live',          label: 'Live', badge: 'LIVE' },
    { to: '/promotions',    label: 'Promos', badge: '🎁' },
    { to: '/championnat',   label: 'Champion', badge: '🏆' },
    ...(user ? [
      { to: '/mes-paris', label: 'Mes Paris' },
    ] : []),
  ];

  return (
    <nav className="navbar">
      <div className="navbar-inner">
        {/* ── Left ── */}
        <div className="navbar-left">
          <button className="hamburger" onClick={() => setMenuOpen(!menuOpen)} aria-label="Menu">
            <span /><span /><span />
          </button>
          <Link to="/" className="navbar-brand">
            <img src={afribet} alt="AfriBet" className="navbar-logo-img" />
            <span className="navbar-logo">Afri<span className="logo-accent">Bet</span></span>
          </Link>
          <div className="navbar-links">
            {navLinks.map(({ to, label, badge }) => (
              <Link
                key={to}
                to={to}
                className={`nav-link ${location.pathname === to ? 'active' : ''}`}
              >
                {label}
                {badge && (
                  <span className={`nav-badge${badge === '🏆' ? ' nav-badge--trophy' : ''}`}>
                    {badge}
                  </span>
                )}
              </Link>
            ))}
          </div>
        </div>

        {/* ── Right ── */}
        <div className="navbar-right">
          <button className="theme-toggle" onClick={toggleTheme} aria-label="Toggle theme">
            {theme === 'light' ? <FaMoon /> : <FaSun />}
          </button>

          {user ? (
            <>
              {/* Balance chip — links to wallet */}
              <Link to="/compte" className="user-balance" title="Mon portefeuille">
                <span className="balance-label">Solde</span>
                <span className="balance-amount">{balance.toLocaleString('fr-FR')} FC</span>
              </Link>

              <Link to="/compte" className="btn-deposit">+ Dépôt</Link>

              {/* User dropdown */}
              <div className="user-dropdown-wrap" ref={userMenuRef}>
                <button className="user-chip" onClick={() => setUserMenu(!userMenu)}>
                  <div className="user-avatar">{(user.username ?? user.name ?? '?').charAt(0).toUpperCase()}</div>
                  <span className="user-name">{user.username ?? user.name}</span>
                  <span className="dropdown-arrow">{userMenu ? <FaChevronUp size={10}/> : <FaChevronDown size={10}/>}</span>
                </button>

                {userMenu && (
                  <div className="user-dropdown">
                    <div className="ud-header">
                      <div className="ud-avatar">{(user.username ?? user.name ?? '?').charAt(0).toUpperCase()}</div>
                      <div>
                        <p className="ud-name">{user.username ?? user.name}</p>
                        <p className="ud-email">{user.email}</p>
                      </div>
                    </div>

                    <div className="ud-divider" />

                    <Link to="/compte" className="ud-item" onClick={() => setUserMenu(false)}>
                      <FaUser /> Mon profil
                    </Link>
                    <Link to="/compte" className="ud-item" onClick={() => setUserMenu(false)}>
                      <FaBullseye /> Mes Paris
                    </Link>
                    <Link to="/compte" className="ud-item" onClick={() => setUserMenu(false)}>
                      <FaWallet /> Mon portefeuille
                      <span className="ud-balance">{balance.toLocaleString('fr-FR')} FC</span>
                    </Link>

                    <div className="ud-divider" />

                    <button className="ud-item ud-logout" onClick={() => { onLogout(); setUserMenu(false); }}>
                      <FaSignOutAlt /> Déconnexion
                    </button>
                  </div>
                )}
              </div>
            </>
          ) : (
            <div className="auth-buttons">
              <button className="btn-login" onClick={() => navigate('/login')}>Connexion</button>
              <button className="btn-register" onClick={() => navigate('/register')}>S'inscrire</button>
            </div>
          )}

          {betCount > 0 && (
            <div className="betslip-float-badge">{betCount}</div>
          )}
        </div>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="mobile-menu">
          {navLinks.map(({ to, label }) => (
            <Link key={to} to={to} className="mobile-nav-link" onClick={() => setMenuOpen(false)}>
              {label}
            </Link>
          ))}
          {user && (
            <>
              <div className="mobile-divider" />
              <Link to="/compte"    className="mobile-nav-link" onClick={() => setMenuOpen(false)}><FaUser /> Mon profil</Link>
              <Link to="/compte"    className="mobile-nav-link" onClick={() => setMenuOpen(false)}><FaBullseye /> Mes Paris</Link>
              <Link to="/compte"    className="mobile-nav-link" onClick={() => setMenuOpen(false)}><FaWallet /> Portefeuille</Link>
              <button className="mobile-nav-link mobile-logout" onClick={() => { onLogout(); setMenuOpen(false); }}>
                <FaSignOutAlt /> Déconnexion
              </button>
            </>
          )}
        </div>
      )}
    </nav>
  );
}
